export default __webpack_public_path__ + "static/media/carouselArrowLeft.b4f13527.svg";